import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Container, Card } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdBadge, faIdCard, faReceipt, faUsers } from '@fortawesome/free-solid-svg-icons'
import '../../../styles/diario.scss';


function HomeLoggedScreen() {
    const [direct, setDirect] = useState(false);
    const [adm, setAdm] = useState(false);
    const nome = localStorage.getItem('nome');
    

    const redireciona = async () => {
        await getNivel();
    }

    const getNivel = async () => {
        let user = localStorage.getItem('nivel');
        if (user === "Administradora") {
            setAdm(true)
        }
    }

    useEffect(() => {
        redireciona()
    }, [])

    if (direct) {
        return <Navigate to={{ pathname: `${direct}` }} />
    } else {
        return (
            <Fragment>
                <Container>
                    <h5>Bem vinda, {nome}, o que deseja fazer?</h5><br />
                    <Row xs={1} lg={4}>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/rh/holerites')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={1}>
                                                <Col>
                                                    <FontAwesomeIcon className='icon-cad' icon={faReceipt} />
                                                </Col>
                                                <Col>
                                                    <p className='titulo-home'>Holerites</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/rh/funcionarios')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={1}>
                                                <Col>
                                                    <FontAwesomeIcon className='icon-cad' icon={faIdBadge} />
                                                </Col>
                                                <Col>
                                                    <p className='titulo-home'>Funcionários</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/rh/cargos')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={1}>
                                                <Col>
                                                    <FontAwesomeIcon className='icon-cad' icon={faIdCard} />
                                                </Col>
                                                <Col>
                                                    <p className='titulo-home'>Cargos</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        {adm ? 
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/rh/rh')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={1}>
                                                <Col>
                                                    <FontAwesomeIcon className='icon-cad' icon={faUsers} />
                                                </Col>
                                                <Col>
                                                    <p className='titulo-home'>Funcionárias RH</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col> : null}
                    </Row>
                </Container>
            </Fragment>
        );
    }
}

export default HomeLoggedScreen;